// Tiny reusable search filter input used above admin list views (blogs,
// pathways, glossary, …). Keeps its own value in the parent's state so
// the parent controls what's filtered.
//
// Usage:
//   <ListFilter value={q} onChange={setQ} placeholder="Filter …" testId="admin-blogs-filter"/>
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";

export default function ListFilter({ value, onChange, placeholder = "Filter…", testId = "list-filter", className = "" }) {
  return (
    <div className={`relative ${className}`}>
      <Search className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none"/>
      <Input
        data-testid={testId}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="pl-9 pr-16"
      />
      {value && (
        <button
          type="button"
          data-testid={`${testId}-clear`}
          onClick={() => onChange("")}
          className="absolute right-2 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-700 text-xs uppercase tracking-widest"
          title="Clear filter">
          Clear
        </button>
      )}
    </div>
  );
}
